/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {AlainThemeConfig as Éµa} from './src/app/services/theme.config';